.userGroup {
  align-items: center;
  display: flex;
  margin: var(--space-big) 0;

  --avatar-size: 25px;
}


.userGroup.noMargin {
  margin: 0;
}

.avatar div {
  box-shadow: 0 0 4px #0004;
  transition: all 0.2s ease-in-out;
}

.avatar:hover div {
  box-shadow: 0 0 4px #000;
}

.avatar:not(:first-child, :only-child) {
  margin-left: calc(-1 * var(--space-small));
}

.excess {
  font-size: var(--font-size-7);
  line-height: var(--line-size-7);
  margin-left: var(--space-small);
}
